import { render, staticRenderFns } from "./ExpiredLinkState.vue?vue&type=template&id=47ae3070&lang=pug"
import script from "./ExpiredLinkState.vue?vue&type=script&lang=ts"
export * from "./ExpiredLinkState.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports